/**
 * Краткое описание последнего смыслового выката (для блока «Профиль»).
 * Обновляйте при релизе вместе с коммитом; git SHA в UI подставляется автоматически из Vercel.
 */
export const WEBAPP_RELEASE_BLURB =
  'Профиль: отладочный блок версии только у админа внизу вкладки; у остальных — одна строка сборки. Meta onviz-webapp-commit в HTML для проверки кэша. Галерея: /uploads/… → текущий API. Конфигуратор: без автовыбора, прогресс внизу карточки, чипы после касания.';
